<!--
 * @Author: your name
 * @Date: 2020-06-16 08:53:23
 * @LastEditTime: 2022-08-18 17:12:11
 * @LastEditors: zhouhx
 * @Description: In User Settings Edit
 * @FilePath: \1-trunk\src\components\basics\first-nav.vue
-->
<template>
  <div class="firstnav" style="width: 100%">
    <div class="nav">
      <ul :class="{numNav: navstatus, normalNav: !navstatus}">
        <li v-for="(item,key) in navData" :key="key" @click="getClickFirstnav(item, key)" :class="{ isactive: activeIndex === key }" :style="{ width: width }">
          <span>{{item.text}}</span>
          <i v-if="item.num">{{item.num}}</i>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    navData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    navstatus: {
      type: Boolean,
      default: false
    },
    indexs: {
      type: Number,
      default: 0
    }
  },
  watch: {
  },
  data () {
    return {
      activeIndex: 0,
      width: ''
    }
  },
  created () {
    this.activeIndex = this.indexs
    // if (this.navData.length === 1) {
    //   this.width = '100%'
    // } else if (this.navData.length === 2) {
    //   this.width = '50%'
    // } else if (this.navData.length === 3) {
    //   this.width = '33%'
    // } else if (this.navData.length === 4) {
    //   this.width = '25%'
    // } else if (this.navData.length > 4) {
    //   this.width = '23%'
    // }
  },
  methods: {
    getClickFirstnav (data, key) {
      this.activeIndex = key
      this.$emit('getClickFirstnav', data.status, key, data);
    }
  }
};
</script>
<style lang="scss" scoped>
.nav {
    width: 100%;
    clear: both;
    background: $white;
    .numNav {
      padding: 0 25px;
    }
    ul {
      box-shadow: $shadow3;
      z-index: 1;
      height: 50px;
      white-space: nowrap;
      overflow-x: scroll;
      li {
        list-style: none;
        text-align: center;
        display: inline-block;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
        width: 25%;
      }
      .isactive {
        color: $blue;
        position: relative;
        // z-index: 1;
        span {
          color: $blue;
          border-bottom: 3px solid $blue;
        }
      }
      span {
        height: 100%;
        display: inline-block;
        font-size: 16px;
        color: $grey;
        letter-spacing: 0;
        margin: 0 4px 0 0;
      }
      i{
        display: inline-block;
        font-style: normal;
        font-size: 14px;
        color: $grey;
        letter-spacing: 0;
        background: $greyef;
        border-radius: 10px;
        width: 36px;
        height: 20px;
        text-align: center;
        line-height: 20px;
      }
    }
  }
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}
</style>
